/* @flow */

import React from 'react';
import ReactDOM from 'react-dom';
import { applyMiddleware, createStore, compose } from 'redux';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import { Container } from 'reactstrap';
import ScrollToTop from 'react-scroll-up';
import FaArrowCircleOUp from 'react-icons/lib/fa/arrow-circle-o-up';

import Header from './components/Header';
import Footer from './components/Footer';
import ModalWrapper from './components/ModalWrapper';

// import registerServiceWorker from './registerServiceWorker';
import App from './App';

// Import the index reducer and sagas
import IndexReducer from './reducers';
import IndexSagas from './sagas';

// ------------------------------------
// Rollbar Monitor API Setup
// ------------------------------------

// if (process.env.NODE_ENV !== 'production') {
//   const ReactWastageMonitor = require('react-wastage-monitor').default; // eslint-disable-line global-require
//   ReactWastageMonitor(React, ReactDOM, {
//     exclude: [
//       /Connect\([^)]*\)|TopLevelWrapper|Provider/, // Redux
//       'ei',
//       /withHandlers.*/, // Recompose
//       /BrowserRouter|Router|Route/, // react-router
//       /OutboundLink/, // react-ga
//       /StatelessComponent/, // ignore for now
//     ],
//   });
// }

// Setup the middleware to watch between the Reducers and the Actions
const sagaMiddleware = createSagaMiddleware();

/* eslint-disable */
const composeSetup =
  process.env.NODE_ENV !== "production" &&
  typeof window === "object" &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;
/* eslint-enable */

const store = createStore(
  IndexReducer,
  composeSetup(applyMiddleware(sagaMiddleware)), // allows redux devtools to watch sagas
);

// Begin our Index Saga
sagaMiddleware.run(IndexSagas);

const scrollStyle = {
  position: 'fixed',
  bottom: 50,
  right: 30,
  cursor: 'pointer',
  transitionDuration: '0.2s',
  transitionTimingFunction: 'linear',
  transitionDelay: '0s',
  zIndex: 9990,
};

const AppWrapper = (BaseComponent, localStore) => (
  <Provider store={localStore}>
    <div>
      <ScrollToTop showUnder={160} style={scrollStyle}>
        <span>
          <FaArrowCircleOUp size={80} />
        </span>
      </ScrollToTop>
      <Header title={process.env.REACT_APP_TOOL_NAME} />
      <Container fluid>
        <BaseComponent />
        <footer className="row">
          <Footer />
        </footer>
        <ModalWrapper />
      </Container>
    </div>
  </Provider>
);

ReactDOM.render(
  AppWrapper(App, store),
  document.getElementById('root') || document.createElement('div'),
);

// registerServiceWorker();

if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default; // eslint-disable-line global-require
    ReactDOM.render(
      AppWrapper(NextApp, store),
      document.getElementById('root'),
    );
  });
}



// WEBPACK FOOTER //
// ./src/main.js